import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-structure',
  templateUrl: './structure.component.html',
  styleUrls: ['./structure.component.css']
})
export class StructureComponent implements OnInit {

  currentstate: any;
  screen: boolean = true;
  constructor() { }

  ngOnInit(): void {
    this.currentstate = 1;

    if( window.screen.width<768){
      this.screen = false;
    }
  }

  navnext(){
    if(this.currentstate == 4){
      this.currentstate = 1;
    }
    else{
      this.currentstate++;
    }
  }

  navprev(){
    if(this.currentstate == 1){
      this.currentstate = 4;
    }
    else{
      this.currentstate--;
    }
  }

  changeblock(){
    if(this.currentstate==4){
      this.currentstate =1;
    }
    else{
      this.currentstate++;
    }
    console.log(this.currentstate)
  }

  next(val: any){
    if(val == 1){
      this.currentstate = 1;
    }
    else if(val == 2){
      this.currentstate = 2;
    }
    else if(val == 3){
      this.currentstate = 3;
    }
    else if(val == 4){
      this.currentstate = 4;
    }
    else{
      this.currentstate = 1;
    }
  }

  prev(){
    this.currentstate--;
  }

}
